module.exports = __webpack_public_path__ + "assets/b476bd82457e3893be9d58ff363c55b1.png";